import RotateObjectLeftIconPath from "@ingka/ssr-icon/paths/rotate-object-left";

export default RotateObjectLeftIconPath;
